import React, { useEffect, useState,useCallback, useRef,Suspense } from "react"; 
import {getdevicetagsModified, statusTableApi } from  "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography, Tooltip } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrievalModified from './AssetTagsRetrievalModified';
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LK_Delete from "../../images/LK_Delete";
import StatusTableDashboard from './StatusTableDashboard';
import TagSelection from './TagSelection';
import '../../cssfiles/homepage.css'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";

// Add global styles for select dropdown options
const selectStyles = document.createElement('style');
selectStyles.innerHTML = `
    select option {
        padding: 4px 8px !important;
    }
    select option:hover {
        background-color: #005C8E !important;
        color: #000000 !important;
    }
    select option:checked {
        background-color: #005C8E !important;
        color: #000000 !important;
        font-weight: 700 !important;
    }
    select::-webkit-scrollbar {
        width: 4px;
    }
    select::-webkit-scrollbar-track {
        background: var(--secondary-backgroundLK);
        border-radius: 0px;
        margin: 4px 0px;
    }
    select::-webkit-scrollbar-thumb {
        background: #008CD7;
        border-radius: 5px;
    }
`;
if (!document.head.querySelector('#select-dropdown-styles')) {
    selectStyles.id = 'select-dropdown-styles';
    document.head.appendChild(selectStyles);
}

export default function StatusTable() {
        // Prevent duplicate warning from being re-triggered immediately after closing
        const duplicateWarningBlocked = useRef(false);
    const [viewDashboard, setViewDashboard] = useState(false);
    const [openDashboardDialog, setOpenDashboardDialog] = useState(false);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const themechange = useSelector((state) => state.themedata.theme)
    const [dashboardName, setDashboardname] = useState('')
    const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [assetdata,setAssetData] = useState(null);
    const [assetdataerror,setAssetDataError] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
    const [selectedTags, setSelectedTags] = useState([]); // Selected tags for 
    const [focusedFieldKey, setFocusedFieldKey] = useState(null);
    const [createdSucess, setCreatedSuccess] = useState(false);
    const [createdMessage, setCreatedMessage] = useState('');
    const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
    const [notCreatedMessage, setNotCreatedMessage] = useState('');
    const [openAlertRuleNameExceedsLength, setopenAlertRuleNameExceedsLength] = useState(false);
    const [numberOfTags, setNumberOfTags] = useState(50);
    const [visibleTags, setVisibleTags] = useState(50);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const scrollContainerRef = useRef(null);
    const [showAliasFlag, setShowAliasFlag] = useState(true);
    const [duplicateTagDialogOpen, setDuplicateTagDialogOpen] = useState(false);
    const [duplicateTagDialogMsg, setDuplicateTagDialogMsg] = useState("");
    
    // API Handler with dialog control
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });
    
    // Initialize dashboard configuration with 50 tag fields
    const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject)
    const devicedetailsobject = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const initializeTags = (count) => {
        const tags = [];
        for (let i = 0; i < count; i++) {
            tags[i] = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation:''
            };
        }
        return tags;
    };
    
    const [dashboardConfig, setDashboardConfig] = useState(() => {
        return {
            dashboardName: '',
            tags: initializeTags(50)
        };
    });

    // UseEffect to handle selected tag application to focused field (now includes aggregation)
    useEffect(() => {
        if (duplicateTagDialogOpen) {
            duplicateWarningBlocked.current = true;
            return;
        }
        // Only allow duplicate warning to be re-triggered after dialog is closed
        if (duplicateWarningBlocked.current && !duplicateTagDialogOpen) {
            duplicateWarningBlocked.current = false;
            return;
        }
        if (focusedFieldKey && selectedTag?.tagname) {
            // Gather all assigned tagids except the current placeholder
            const assignedTagIds = new Set();
            dashboardConfig.tags.forEach((tag, idx) => {
                if (tag.enabled && `tags[${idx}]` !== focusedFieldKey) {
                    assignedTagIds.add(tag.tagid);
                }
            });
            // If selectedTag.tagid is already assigned elsewhere, show warning and ignore
            if (assignedTagIds.has(selectedTag.tagid)) {
                if (!duplicateWarningBlocked.current) {
                    setDuplicateTagDialogMsg(`The tag '${selectedTag.tagname}' is already assigned to another placeholder. Please select a different tag.`);
                    setDuplicateTagDialogOpen(true);
                }
                return;
            }
            // Otherwise, assign as usual
            const updatedConfig = { ...dashboardConfig };
            const keys = focusedFieldKey
                .replace(/\[(\d+)\]/g, '.$1')
                .split('.');
            let obj = updatedConfig;
            for (let i = 0; i < keys.length - 1; i++) {
                const key = isFinite(keys[i]) ? Number(keys[i]) : keys[i];
                obj = obj[key];
            }
            const finalKey = keys[keys.length - 1];
            if (obj[finalKey]) {
                obj[finalKey].value = selectedTag.tagname;
                obj[finalKey].tagid = selectedTag.tagid;
                obj[finalKey].tagname = devicedetailsobject[tagdetailsobject[selectedTag.tagid]?.DeviceID]?.Name + " : "+ tagdetailsobject[selectedTag.tagid]?.Alias;
                obj[finalKey].tagunit = selectedTag.tagunit;
                obj[finalKey].std_tagname = selectedTag.std_tagname;
                obj[finalKey].tagdatatype = selectedTag.tagdatatype;
                obj[finalKey].projectid = selectedTag.projectid;
                obj[finalKey].enabled = true;
                obj[finalKey].aggregation = '';
            }
            setDashboardConfig(updatedConfig);
            setFocusedFieldKey(null);
            setSelectedTag(null);
        }
    }, [selectedTag, focusedFieldKey, dashboardConfig.tags, duplicateTagDialogOpen]);
    // When dialog closes, also clear focusedFieldKey and selectedTag to allow new selection
    const handleCloseDuplicateTagDialog = () => {
        setDuplicateTagDialogOpen(false);
        setFocusedFieldKey(null);
        setSelectedTag(null);
    };

    function handleViewDashboard(){
        setViewDashboard(true);
    }

    function handledashboardNameChange(value){
        console.log("handledashboardNameChange",value)
        setDashboardname(value)
        // Also update the dashboard config
        setDashboardConfig(prev => ({
            ...prev,
            dashboardName: value
        }));
    }
    
    const handleNumberOfTagsChange = (event) => {
        const newCount = parseInt(event.target.value);
        setNumberOfTags(newCount);
        setVisibleTags(Math.min(50, newCount));
        
        // Update dashboard config with new number of tags
        setDashboardConfig(prev => {
            const currentTags = [...prev.tags];
            const newTags = initializeTags(newCount);
            
            // Preserve existing configured tags
            for (let i = 0; i < Math.min(currentTags.length, newCount); i++) {
                newTags[i] = currentTags[i];
            }
            
            return {
                ...prev,
                tags: newTags
            };
        });
    };
    
    const loadMoreTags = useCallback(() => {
        if (isLoadingMore || visibleTags >= numberOfTags) return;
        
        setIsLoadingMore(true);
        setTimeout(() => {
            setVisibleTags(prev => Math.min(prev + 50, numberOfTags));
            setIsLoadingMore(false);
        }, 300);
    }, [isLoadingMore, visibleTags, numberOfTags]);

    function handleAlertRuleNameExceedsLength(){
        setopenAlertRuleNameExceedsLength(false)
    }

    function handleCancelViewDashboard(){
        setViewDashboard(false);
    }

    const handleConfigureDashboard = () => {
        // Reset dashboard config to default
        setDashboardConfig({
            dashboardName: '',
            tags: initializeTags(50)
        });
        setDashboardname('');
        setNumberOfTags(50);
        setVisibleTags(50);
        setOpenDashboardDialog(true);
    }


    // Block focusing or changing placeholder unless a tag is selected
    const handleTagFieldFocus = (index) => {
        if (!selectedTag || !selectedTag.tagid) {
            // setDuplicateTagDialogMsg("Please select a tag first before assigning to a placeholder.");
            // setDuplicateTagDialogOpen(true);
            return;
        }
        setFocusedFieldKey(`tags[${index}]`);
        console.log("Focused field:", `tags[${index}]`);
    }

    const handleTagFieldChange = (index, value) => {
        if (!selectedTag || !selectedTag.tagid) {
            setDuplicateTagDialogMsg("Please select a tag first before assigning to a placeholder.");
            setDuplicateTagDialogOpen(true);
            return;
        }
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                ...updated.tags[index],
                value: value,
                enabled: true
            };
            return updated;
        });
        setSelectedTag(null);
    }

    // Handle aggregation change for a tag
    const handleAggregationChange = (index, aggValue) => {
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                ...updated.tags[index],
                aggregation: aggValue
            };
            return updated;
        });
    }

    // Handle tag field clear
    const handleClearTagField = (index) => {
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation: ''
            };
            return updated;
        });
    }

    function handleSaveChange() {
        // Save the complete dashboard configuration
        const configuredTags = dashboardConfig.tags.filter(tag => tag.enabled && tag.tagname);
        // Each tag now includes aggregation
        console.log("Saving dashboard configuration:", {
            dashboardName: dashboardConfig.dashboardName,
            configuredTags: configuredTags
        });
        if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
            const saveData = {
                dashboardName: dashboardConfig.dashboardName,
                tags: configuredTags, // includes aggregation
                projectId: userdetails.Projectid,
                organizationId: userdetails.Organizationid
            };
            console.log("Save maintenance details request:", saveData);
        }
    }
     
    const assetcallback = (res) => {
        console.log("res obtd in assetscallback in OverviewHomePage",res)
        if(res.success == true){
            setAssetData({devices: res.devices});
        }else{
            setAssetData({devices: {}});
        }
    };

    useEffect(() => {
         getdevicetagsModified(assetcallback)
    }, [selectedprojectname]);

     const handleCloseCreateDashboard = useCallback(() => {
            setCreatedSuccess(false)
        }, []);
    
        const handleCloseNotCreateDashboard = useCallback(() => {
            setNotCreatedSuccess(false)
        }, []);

    const handleSaveConfiguredDashboard = async () => {
        if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
            const configuredTags = dashboardConfig.tags.filter(tag => tag.enabled && tag.tagid);
    
            if((!isValidLength(dashboardConfig.dashboardName,5,30)) || (containsSpacesOrSpecialChars(dashboardConfig.dashboardName))){
                setopenAlertRuleNameExceedsLength(true)
                return;
            }

            const payload = {
                dashboardName: dashboardConfig.dashboardName,
                DashboardProjectID:"",
                DashboardOrganizationID:"",
                numberOfTags:numberOfTags,
                tags: configuredTags,
                projectId: userdetails.Projectid === "All" ? selectedprojectname : userdetails.Projectid,
                organizationId: userdetails.Organizationid,
                action:"CREATE",
                dashboard_pro:null,
            };
            console.log("Payload to save dashboard: Create", payload);
            
            await callApi(
                () => statusTableApi.createDashboard(payload),
                {
                    showDialog: false,
                    hideDialogOnStatusCodes: [404],
                    showDialogOnCatch: false,
                    useBackendMessage: true,
                    onSuccess: (response) => {
                        console.log("Dashboard created successfully:", response);
                        if (response.data.success && response.data.data && response.data.data.data) {
                            setCreatedSuccess(true);
                        } else {
                            setNotCreatedMessage(response.data.message || "Failed to create dashboard");
                            setNotCreatedSuccess(true);
                        }
                    },
                    onError: (error) => {
                        console.error("Error creating dashboard:", error);
                        setNotCreatedMessage(error?.message || "Failed to create dashboard");
                        setNotCreatedSuccess(true);
                    },
                    onCatchError: (error, errorInfo) => {
                        // Handle unexpected errors (network failures, exceptions, etc.)
                        console.error("Unexpected error creating dashboard:", error, errorInfo);
                        setNotCreatedMessage(error?.message || "Network error or unexpected failure. Please try again.");
                        setNotCreatedSuccess(true);
                        setOpenDashboardDialog(false);
                    }
                }
            );
        } else {
            console.error("User details are not available or invalid.");
        }
        
        setOpenDashboardDialog(false);
    }
    
    const handleCloseConfigureDashboard = () => {
        setOpenDashboardDialog(false);
        setDashboardConfig({
            dashboardName: '',
            tags: initializeTags(50)
        });
        setDashboardname('');
        setNumberOfTags(50);
        setVisibleTags(50);
        setSelectedTag({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:'' });
        setSelectedAsset({asset_name:'', device_id:''});
        setFocusedFieldKey(null);
        // setAssetData(null);
        setAssetDataError(false);
        setShowAliasFlag(true);
        setExistingDeviceTagAlarmConfig(false);
    }

    // Render tag configuration fields (with aggregation dropdown)
    // const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject) || {};
    const renderTagConfigFields = () => {
        const visibleTagsArray = dashboardConfig.tags.slice(0, visibleTags);
        
        return (
            <Box sx={{ marginTop: '20px', maxHeight: '400px', overflowY: 'auto', paddingRight: '32px' }} ref={scrollContainerRef}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <Typography sx={{
                        fontSize: "18px",
                        fontFamily: "Roboto",
                        color:'var(--SecondaryText)',fontWeight: 400,
                    }}>
                        Tag Configuration: Select number of tags to configure
                    </Typography>
                    <FormControl size="small" sx={{ minWidth: 150 }}>
                        <select
                            value={numberOfTags}
                            onChange={handleNumberOfTagsChange}
                            style={{ 
                                marginLeft: '8px',
                                height: '30px',
                                minWidth: '220px',
                                fontSize: '14px',
                                fontFamily: 'Roboto',
                                fontWeight: '700',
                                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF',
                                backgroundColor: themechange === 'light' ? '#FFFFFF' : '#19191B',
                                border: 'none',
                                borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`,
                                borderRadius: '0',
                                padding: '0 4px',
                                outline: 'none',
                                cursor: 'pointer',
                                scrollbarWidth: 'thin',
                                scrollbarColor: `#008CD7 ${themechange === 'light' ? '#ffffff' : '#1e1e1e'}`
                            }}
                            onFocus={(e) => {
                                e.target.style.borderBottom = '2px solid #008CD7';
                                e.target.style.color = '#008CD7';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                e.target.style.color = themechange === 'light' ? '#3C3C3C' : '#FFFFFF';
                            }}
                            onMouseEnter={(e) => {
                                if (document.activeElement !== e.target) {
                                    e.target.style.borderBottom = '2px solid #008CD7';
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (document.activeElement !== e.target) {
                                    e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                }
                            }}
                        >
                            <option value={50} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>50 Tags</option>
                            <option value={100} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>100 Tags</option>
                            <option value={150} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>150 Tags</option>
                            <option value={200} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>200 Tags</option>
                            <option value={250} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>250 Tags</option>
                            <option value={300} style={{ 
                                backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                padding: '4px 8px'
                            }}>300 Tags</option>
                        </select>
                    </FormControl>
                </Box>
                <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px',  }}>
                    {visibleTagsArray.map((tag, index) => {
                        // Get unique aggregation options (Function) for this tag
                        let uniqueAggs = [];
                        if (tag.tagid && tagdetailsobject[tag.tagid]?.StorageID) {
                            const seen = new Set();
                            uniqueAggs = tagdetailsobject[tag.tagid].StorageID.filter(agg => {
                                if (!agg.Function || seen.has(agg.Function)) return false;
                                seen.add(agg.Function);
                                return true;
                            });
                        }
                        return (
                        <Box key={index} sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: '20px',
                            padding: '10px',
                            width: "320px",
                            border: '1px solid #005C8E',
                            borderRadius: '8px',
                            backgroundColor:'rgba(0, 92, 142, 0.1)'
                        }}>
                            <Typography sx={{ 
                                minWidth: '60px', 
                                fontSize: '14px',
                                fontWeight: 600,
                                color: '#005C8E'
                            }}>
                                Tag {index + 1}:
                            </Typography>
                            <Tooltip 
                                title={(() => {
                                    const tagObj = tagdetailsobject[tag.tagid];
                                    const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                                    const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                                    const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                                    return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
                                })()}>
                                <TextField
                                    value={(() => {
                                        const tagObj = tagdetailsobject[tag.tagid];
                                        const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                                        const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                                        const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                                        return `${deviceName}: ${showAliasFlag ? alias : name}`;
                                    })()}
                                    placeholder="Select tag"
                                    variant="standard"
                                    width="94px"
                                    size="small"
                                    onFocus={() => handleTagFieldFocus(index)}
                                    onChange={(e) => handleTagFieldChange(index, e.target.value)}
                                    onKeyDown={e => e.preventDefault()}
                                    disabled={!selectedTag || !selectedTag.tagid}
                                    sx={{
                                        flexGrow: 1,
                                        '& .MuiOutlinedInput-root': {
                                            fontSize: '14px',
                                            height: '35px',
                                            color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                        },
                                        '& .MuiOutlinedInput-input::placeholder': {
                                            color: themechange === 'light' ? '#7e7e7e' : '#5b5b5b',
                                            opacity: 1
                                        },
                                         '& .MuiInputBase-input:focus': {
                                                    color: '#008CD7',
                                                },
                                                '& .MuiInputBase-root': {
                                                    fontFamily: 'Roboto',
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                },
                                                '& .MuiInput-root .MuiInputBase-input': {
                                    
                                                },
                                                '& .MuiInputBase-root::before': {
                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                    borderBottom: '2px solid #008CD7',
                                                },
                                                '& .MuiInputBase-root::after': {
                                                    borderBottom: '2px solid #008CD7',
                                                
                                                },
                                    }}
                                />
                            </Tooltip>
                            {/* Aggregation dropdown for enabled tags with tagid and StorageID */}
                            {console.log("Rendering tag field:", tagdetailsobject,"tagdetailsobject[tag.tagid]",tagdetailsobject[tag.tagid],"tag",tag)   }
                            {tag.tagid && tagdetailsobject[tag.tagid]?.StorageID && (
                                <select
                                    value={tag.aggregation || ''}
                                    onChange={e => handleAggregationChange(index, e.target.value)}
                                    style={{ 
                                        marginLeft: '8px',
                                        height: '30px',
                                        minWidth: '120px',
                                        fontSize: '14px',
                                        fontFamily: 'Roboto',
                                        fontWeight: '700',
                                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF',
                                        backgroundColor: themechange === 'light' ? '#FFFFFF' : '#19191B',
                                        border: 'none',
                                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`,
                                        borderRadius: '0',
                                        padding: '0 4px',
                                        outline: 'none',
                                        cursor: 'pointer',
                                        scrollbarWidth: 'thin',
                                        scrollbarColor: `#008CD7 ${themechange === 'light' ? '#ffffff' : '#1e1e1e'}`
                                    }}
                                    onFocus={(e) => {
                                        e.target.style.borderBottom = '2px solid #008CD7';
                                        e.target.style.color = '#008CD7';
                                    }}
                                    onBlur={(e) => {
                                        e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                        e.target.style.color = themechange === 'light' ? '#3C3C3C' : '#FFFFFF';
                                    }}
                                    onMouseEnter={(e) => {
                                        if (document.activeElement !== e.target) {
                                            e.target.style.borderBottom = '2px solid #008CD7';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (document.activeElement !== e.target) {
                                            e.target.style.borderBottom = `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`;
                                        }
                                    }}
                                >
                                    <option value="" style={{ 
                                        backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                        color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                        padding: '4px 8px'
                                    }}>Select Aggregation</option>
                                    {uniqueAggs.map((agg, i) => (
                                        <option key={i} value={agg.Function} style={{ 
                                            backgroundColor: themechange === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                            color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                            padding: '4px 8px'
                                        }}>
                                            {agg.Function}
                                        </option>
                                    ))}
                                </select>
                            )}
                            { (
                                <Button
                                    size="small"
                                    onClick={() => handleClearTagField(index)}
                                    sx={{
                                        minWidth: '30px',
                                        width: '30px',
                                        height: '30px',
                                        color: '#ff6b6b',
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 107, 107, 0.1)'
                                        }
                                    }}
                                >
                                    ×
                                </Button>
                            )}
                        </Box>
                    )})}
                </Box>
                {visibleTags < numberOfTags && (
                    <Box sx={{ textAlign: 'center', padding: '20px' }}>
                        <Button
                            variant="contained"
                            onClick={loadMoreTags}
                            disabled={isLoadingMore}
                            sx={{
                                backgroundColor: '#005C8E',
                                color: '#FFFFFF',
                                borderRadius: '20px',
                                textTransform: 'none',
                                fontSize: '14px',
                                padding: '8px 24px',
                                '&:hover': {
                                    backgroundColor: '#004A73'
                                },
                                '&:disabled': {
                                    backgroundColor: '#ccc'
                                }
                            }}
                        >
                            {isLoadingMore ? 'Loading...' : `Load More (${visibleTags} / ${numberOfTags} shown)`}
                        </Button>
                    </Box>
                )}
                <Typography sx={{
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    color: 'var(--SecondaryText)',
                    fontWeight: 400,
                    marginTop: "10px",
                    fontStyle: 'italic'
                }}>
                    Configured Tags: {dashboardConfig.tags.filter(tag => tag.tagid).length} / {numberOfTags}
                </Typography>
            </Box>
        );
    }

    function isValidLength(value, minLength, maxLength){
        return value.length >= minLength && value.length <= maxLength;
    }

    function isValidNumber(value, minNumber, maxNumber){
        return Number(value) >= Number(minNumber) && Number(value) <= Number(maxNumber);
    }

    function containsSpacesOrSpecialChars(str) {
        // Allow spaces and underscores, but reject other special characters
        return /[^\w\s]/.test(str);
    }


    return (
        <>
            {(viewDashboard == false) &&  
                        <Box className="compliance-config" style={{width: "100%",boxSizing: 'border-box'}}>
                            <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                {/*<Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"8px",textAlign:"left",marginTop:"10px"}}>Select Device to configure Scheduled and Condition Based Maintenance</Typography> */}
                                <Box sx={{flexGrow:1}}></Box>
                                {/* <Button id={props.index} onClick={props.saveForm}>Save</Button> */}
                                <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                                    <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                        <CustomButton /*id={assetInfo.id}*/ onClick={handleViewDashboard} buttonText={'View Dashboard'} width={'200px'} />
                                        <CustomButton /*id={assetInfo.id}*/ onClick={handleConfigureDashboard} buttonText={'Configure Dashboard'} width={'200px'} />
                                    </Box> 
                                </div>
                                <div style={{marginTop:"10px", marginRight:"5px",marginBottom:"10px",}}>
                                    <CustomButton onClick={handleSaveChange} buttonText={'Save'} width={'120px'} />
                                </div>
                            </Box>
                             <Dialog
                                open={openDashboardDialog}
                                onClose={handleCloseConfigureDashboard}
                                fullWidth
                                maxWidth="xl"
                                BackdropProps={{
                                    sx: {
                                        backgroundColor: themechange === 'light' ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.3)',
                                    },
                                }}
                                sx={{
                                    "& .MuiDialog-paper": {
                                        height: "85vh",
                                        width: "100%",
                                        borderTopLeftRadius: "40px",
                                        borderTopRightRadius: "40px",
                                        overflow: "auto",
                                        backgroundColor: themechange === 'light' ? "#FFFFFF" : "#19191B",
                                    },
                                }}
                                className={themechange}
                            >
                                <DialogTitle
                                    sx={{
                                        color: "#FFFFFF",
                                        backgroundColor: "#005C8E",
                                        margin: "5px",
                                        borderRadius: "100px",
                                    }}
                                >
                                    Configure Dashboard
                                </DialogTitle>
                                <DialogContent
                                    sx={{
                                        width: "98%",
                                        height: "100%",
                                        backgroundColor: 'var(--secondary-backgroundLK)',
                                        overflow: "auto",
                                        position: "relative",
                                    }}
                                >
                                    {/* <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>{"Please configure your Status Table dashboard with up to " + numberOfTags + " tags"}</Typography> */}
                                    
                                    <div style={{ width:"100%",display: 'flex', flexDirection: 'row', gap:"30px",marginTop:"20px" }}>
                                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color: themechange === 'light' ? '#3C3C3C' : '#C1C1C1',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>{"Enter Status Table dashboard name"}</Typography>
                                        <TextField
                                            required
                                            className="textfield"
                                            sx={{
                                                marginLeft: "16px",
                                                marginTop: "0px",
                                                fontSize: "16px",
                                                fontFamily: "Roboto",
                                                marginLeft: "14px",
                                                width: "500px",
                                                maxWidth: "500px",
                                                '& .MuiInputBase-input:focus': { color: '#008CD7' },
                                                '& .MuiInputBase-root': {
                                                    fontFamily: 'Roboto',
                                                    fontSize: '16px',
                                                    fontWeight: '700',
                                                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                                },
                                                '& .MuiInputBase-root::before': {
                                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                                },
                                                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                    borderBottom: '2px solid #008CD7',
                                                },
                                                '& .MuiInputBase-root::after': {
                                                    borderBottom: '2px solid #008CD7',
                                                },
                                            }}
                                            label=""
                                            width="500px"
                                            maxWidth="500px"
                                            value={dashboardName}
                                            variant="standard"
                                            onChange={e => handledashboardNameChange(e.target.value)}
                                            inputProps={{ minLength: 5, maxLength: 30 }}
                                            helperText={
                                                (dashboardName.length > 0 && (!isValidLength(dashboardName, 5, 30) || containsSpacesOrSpecialChars(dashboardName)))
                                                    ? `Length must be between 5 and 30 characters. Only letters, numbers, spaces, and underscores are allowed. ${dashboardName.length}/30 characters used`
                                                    : `${dashboardName.length}/30 characters used`
                                            }
                                            FormHelperTextProps={{
                                                sx: {
                                                    maxWidth: '500px',
                                                    whiteSpace: 'wrap',
                                                    overflow: 'hidden',
                                                    color: (dashboardName.length > 0 && (!isValidLength(dashboardName, 5, 30) || containsSpacesOrSpecialChars(dashboardName))) ? '#DC272D' : '#00943D'
                                                }
                                            }}
                                        />
                                    </div>

                                    <div style={{display:'flex', flexDirection:'row',gap:"40px"}}>
                                        <div style={{marginTop:"65px"}}>
                                                {/* Asset Tags Retrieval Component */}
                                            <AssetTagsRetrievalModified 
                                                assetdata={assetdata} 
                                                setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                                setSelectedTag={setSelectedTag} 
                                                setSelectedAsset={setSelectedAsset}
                                                setShowAliasFlag={setShowAliasFlag} 
                                                selectedTag={selectedTag}
                                            />
                                        </div>
                                        <div>
                                                {/* Render 50 Tag Configuration Fields */}
                                                {renderTagConfigFields()}
                                        </div>
                                    </div>
                                    

                                   
                                    
                                </DialogContent>
                                <DialogActions sx={{ justifyContent: 'center' }}>
                                    <Button
                                        onClick={handleSaveConfiguredDashboard}
                                        sx={{
                                            outline: 'none !important',
                                            boxShadow: 'none',
                                            height: '35px',
                                            width: '125px',
                                            fontSize: '16px',
                                            textTransform: 'capitalize',
                                            marginRight: '5px',
                                            backgroundColor: '#005C8E',
                                            borderRadius: '20px',
                                        }}
                                        variant="contained"
                                        autoFocus
                                    >
                                        Create
                                    </Button>
                                    <CustomCancelButton onClick={handleCloseConfigureDashboard} buttonText={'Cancel'} />
                                </DialogActions>
                            </Dialog>
                        </Box>}
            {(viewDashboard == true) && 
                        <Suspense fallback={<div>Loading Dashboard...</div>}>
                                <Box className="compliance-config" sx={{height :"100%",boxSizing:"border-box", width:"100%" }}>
                                    <Box  sx={{padding:"0px",height:'calc(100% - 0px)',width:"100%" ,boxSizing:"border-box"}} >
                                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                                            <Box sx={{flexGrow:1}}></Box>
                                            <CustomCancelButton onClick={handleCancelViewDashboard} buttonText={'Cancel'}></CustomCancelButton>
                                        </Box>
                                        <StatusTableDashboard />
                                    </Box>
                                </Box>
                        </Suspense>}
                         <CustomDialogBox dialogTitle={"Created Dashboard Successfully"} dialogText={"Dashboard Successfully created "}  openDialog={createdSucess}  handleCloseDialog={handleCloseCreateDashboard}  handleConfirmDialog={handleCloseCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
                         <CustomDialogBox dialogTitle={"Created Dashboard Failed"} dialogText={notCreatedMessage || "Failed to create dashboard .Try Again! "}  openDialog={notCreatedSuccess}  handleCloseDialog={handleCloseNotCreateDashboard}  handleConfirmDialog={handleCloseNotCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                         <CustomDialogBox dialogTitle={"Creation of Dashboard Failed"} dialogText={"Check if Dashboard Name has length between 5-30 characters and no special characters"}  openDialog={openAlertRuleNameExceedsLength}  handleCloseDialog={handleAlertRuleNameExceedsLength}  handleConfirmDialog={handleAlertRuleNameExceedsLength}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                         <CustomDialogBox
                            dialogTitle={"Duplicate Tag Assignment"}
                            dialogText={'You cannot assign the same tag to multiple placeholders. Please select a different tag.'}
                            openDialog={duplicateTagDialogOpen}
                            handleCloseDialog={handleCloseDuplicateTagDialog}
                            handleConfirmDialog={handleCloseDuplicateTagDialog}
                            confirmText={"OK"}
                            type={"Error"}
                        />
        </>
        
    )
}